import { z } from 'zod';

export const checkEmailStatusInputSchema = z
  .object({
    email: z.string().min(1),
  })
  .strict();

export type CheckEmailStatusInput = z.infer<typeof checkEmailStatusInputSchema>;

export interface CheckEmailStatusResponse {
  hasAccount: boolean;
  hasContact: boolean;
  /**
   * True when this email came through the unauthenticated code-request queue
   * and has since been fulfilled with a coded invitation. The mobile client
   * must route this path through invitation-code entry rather than the
   * normal staged-person email-match signup.
   */
  requiresInvitationCode?: boolean;
}
